import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { useAuth } from "../../authentication";
import {
  apiOutletClient,
  formatDate,
  formatDateTime,
  formatMoney,
} from "../../shared";
import { CenteredLoading, CustomDialogTitle } from "../../ui";

export const ExpenseDialog = ({ onClose, expenseId }) => {
  const { outlet } = useAuth();
  const [expense, setExpense] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchExpense = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiOutletClient.get(`expenses/${expenseId}`, {
          params: {
            withUser: true,
            withExpenseCategory: true,
          },
        });
        setExpense(data);
      } finally {
        setIsLoading(false);
      }
    };

    fetchExpense();
  }, [expenseId, outlet.id]);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open onClose={handleClose} fullWidth>
      <CustomDialogTitle variant="h5" title="Biaya" onClose={handleClose} />
      <DialogContent dividers>
        {isLoading ? (
          <CenteredLoading sx={{ height: "10rem" }} />
        ) : (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="caption">Nomor Referensi</Typography>
              <Typography>{expense.referenceNumber}</Typography>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="caption">Tanggal Transaksi</Typography>
              <Typography>{formatDate(expense.transactionDate)}</Typography>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="caption">Dibuat pada</Typography>
              <Typography>{formatDateTime(expense.createdAt)}</Typography>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="caption">Dibuat oleh</Typography>
              <Typography>{expense.user.name}</Typography>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="caption">Kategori</Typography>
              <Typography>{expense.expenseCategory.name}</Typography>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="caption">Nominal</Typography>
              <Typography>{formatMoney(expense.amount)}</Typography>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="caption">Catatan</Typography>
              <Typography>{expense.note ?? "-"}</Typography>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="caption">Lampiran</Typography>
              {expense.attachmentPath ? (
                <Box sx={{
                  mt: 1
                }}>
                  <img
                    src={expense.attachmentPath}
                    style={{
                      maxWidth: "50%",
                      height: "50%",
                      objectFit: "contain",
                    }}
                  ></img>
                </Box>
              ) : (
                <Typography>-</Typography>
              )}
            </Grid>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

ExpenseDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  expenseId: PropTypes.string,
};
